import { render, staticRenderFns } from "./comp_Home-G-Video.vue?vue&type=template&id=7d89f29a&scoped=true&"
import script from "./comp_Home-G-Video.vue?vue&type=script&lang=js&"
export * from "./comp_Home-G-Video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d89f29a",
  null
  
)

export default component.exports